import React from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/dashboard/Sidebar";
import Navbar from "../../components/dashboard/Navbar";
import PersonalInformation from "../../components/dashboard/Profile/PersonalInformation";
import AccountInformation from "../../components/dashboard/Profile/AccountInformation";
import Notifications from "../../components/dashboard/Profile/Notifications";

export default function Profile() {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="wrapper">
      <Sidebar userType="teacher" sideBarEvent={"profile"} />
      <div id="content">
        <div className="content_dashborad_inner">
          <Navbar sideBarEvent="settings" />
          <div>
            <div className="main_section_content">
              <div className="center_content full_width">
                <div className="d-flex">
                  <div className="settings_wrapper">
                    <div>
                      <PersonalInformation />
                      <AccountInformation />
                      <Notifications />
                    </div>
                    <div className="box_border_settings">
                      <div className="settings_header">
                        <h2>Done teaching?</h2>
                        <div className="settings_header">
                          <p className="mb-0 editt cursor"></p>
                        </div>
                      </div>
                      <div className="setting_rows">
                        <p className="key" style={{ width: "70%" }}>
                          Delete your account? This will permanently delete your
                          account and your data, in accordance with applicable
                          law.
                        </p>
                        <p style={{ width: "20%" }}></p>
                        <p
                          className="value"
                          style={{
                            background: "#AE2604",
                            borderRadius: "100px",
                            cursor: "pointer",
                            width: "115px",
                            textAlign: "center",
                            padding: "4px 16px",
                            color: "white",
                          }}
                        >
                          Delete
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="settings_wrapper"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
